import React from 'react';
import { ArrowUp } from 'lucide-react';

const ScrollToTopButton: React.FC = () => {
  const [showScrollTop, setShowScrollTop] = React.useState(false);
  const [lastScrollY, setLastScrollY] = React.useState(0);
  const [scrollDirection, setScrollDirection] = React.useState<'up' | 'down'>('up');

  const handleScroll = React.useCallback(() => {
    const currentScrollY = window.scrollY;
    const direction = currentScrollY > lastScrollY ? 'down' : 'up';
    
    if (direction !== scrollDirection) {
      setScrollDirection(direction);
    }

    setShowScrollTop(currentScrollY > 500);
    setLastScrollY(currentScrollY);
  }, [lastScrollY, scrollDirection]);

  React.useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const scrollToTop = (e: React.MouseEvent) => {
    e.preventDefault();
    
    const duration = 500;
    const start = window.scrollY;
    const startTime = performance.now();

    const animateScroll = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      
      const easeOutCubic = 1 - Math.pow(1 - progress, 3);
      
      window.scrollTo(0, start * (1 - easeOutCubic));

      if (progress < 1) {
        requestAnimationFrame(animateScroll);
      }
    };

    requestAnimationFrame(animateScroll);
  };

  return (
    <button
      onClick={scrollToTop}
      className={`fixed bottom-8 right-8 bg-cancun-purple/90 backdrop-blur-sm text-white p-4 rounded-full shadow-lg hover:bg-cancun-turquoise transition-all duration-300 hover:scale-110 z-50 ${
        showScrollTop
          ? 'opacity-100 translate-y-0'
          : 'opacity-0 translate-y-16 pointer-events-none'
      } ${
        scrollDirection === 'down' ? 'hover:-translate-y-1' : ''
      }`}
      aria-label="Retour en haut"
      style={{
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
      }}
    >
      <ArrowUp size={24} />
    </button>
  );
};

export default ScrollToTopButton;